import name from './name'

const selectSliceData = state => state[name]
const selectTemplates = state => selectSliceData(state).templates

export { selectTemplates }
